import axios from 'axios';
import { resolveAuthHeaderValue } from '@/utils/authToken';
import { apiUrl } from '@/utils/appConfig';

const client = axios.create({ baseURL: apiUrl() });

client.interceptors.request.use(config => {
  const authHeaderValue = resolveAuthHeaderValue();
  if (!authHeaderValue) return config;
  const nextConfig = { ...config };
  if (!nextConfig.headers) nextConfig.headers = {};
  nextConfig.headers.Authorization = authHeaderValue;
  return nextConfig;
});

// Guards against the literal "undefined"/"null" (and other empties) ever being built
// into a `.../runs/{jobId}` URL — the backend expects a numeric path variable and a
// malformed one used to surface as a 500.
function requireJobId(jobId) {
  const text = String(jobId ?? '').trim()
  if (!text || text === 'undefined' || text === 'null') {
    throw new Error(`Invalid jobId: ${jobId}`)
  }
  return text
}

export async function listRuns({ page = 0, size = 20, streamId, status, from, to } = {}) {
  const params = { page, size };
  if (streamId != null) params.streamId = streamId;
  if (status) params.status = status;
  if (from) params.from = from;
  if (to) params.to = to;
  const { data } = await client.get('/api/cmaker/runs', { params });
  return data;
}

export async function getRun(jobId) {
  const { data } = await client.get(`/api/cmaker/runs/${encodeURIComponent(requireJobId(jobId))}`);
  return data;
}

export async function getRunEvents(jobId) {
  const { data } = await client.get(`/api/cmaker/runs/${encodeURIComponent(requireJobId(jobId))}/events`);
  return Array.isArray(data) ? data : [];
}

export async function getRunArticle(jobId) {
  const { data } = await client.get(`/api/cmaker/runs/${encodeURIComponent(requireJobId(jobId))}/article`);
  return data;
}

export async function getRunCost(jobId) {
  const { data } = await client.get(`/api/cmaker/runs/${encodeURIComponent(requireJobId(jobId))}/cost`);
  return data;
}

export async function cancelRun(jobId) {
  await client.post(`/api/cmaker/runs/${encodeURIComponent(requireJobId(jobId))}/cancel`);
}

export async function rerunStep(jobId, step) {
  await client.post(`/api/cmaker/runs/${encodeURIComponent(requireJobId(jobId))}/rerun-step`, { step });
}

export async function deleteRun(jobId) {
  await client.delete(`/api/cmaker/runs/${encodeURIComponent(requireJobId(jobId))}`);
}
